module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bind-phone"
  }, [_c('form', {
    staticClass: "s-form"
  }, [_c('div', {
    staticClass: "s-form-row"
  }, [_c('label', {
    staticClass: "s-form-label"
  }, [_vm._v("我的手机号：")]), _vm._v(" "), _c('div', {
    staticClass: "s-form-info"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }],
    attrs: {
      "type": "phone",
      "name": ""
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }, _vm.validatePhone]
    }
  })])]), _vm._v(" "), _c('send_code', {
    attrs: {
      "type": _vm.v_type,
      "request": _vm.request,
      "is_new": 'true'
    },
    on: {
      "errorResult": _vm.errorResult
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-form-btnrow"
  }, [_c('button', {
    staticClass: "s-button submit s-btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("提交")])])], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    attrs: {
      "name": ""
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("中国+86")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-e4866592!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/validation/phone/bind_phone.vue
// module id = Zndx
// module chunks = 15